import axios from "axios";
import { Buffer } from "buffer";
const API_URL = process.env.REACT_APP_API_Link;
const API_ORIGIN = process.env.REACT_APP_API_ORIGIN;
const username = process.env.REACT_APP_API_USERNAME;
const password = process.env.REACT_APP_API_PASSWORD;
const token = Buffer.from(`${username}:${password}`, "utf8").toString("base64");

const getStates = () => {
  return axios({
    method: "GET",
    url: API_URL + "register/states/" + API_ORIGIN,
    headers: {
      Authorization: `Basic ${token}`,
    },
  });
};

const getStoreLocation = (tokenval) => {
  return axios({
    method: "GET",
    url: API_URL + "register/stores/" + API_ORIGIN + "/" + tokenval,
    headers: {
      Authorization: `Basic ${token}`,
    },
  });
};
const getModels = () => {
  return axios({
    method: "GET",
    url: API_URL + "register/models/" + API_ORIGIN,
    headers: {
      Authorization: `Basic ${token}`,
    },
  });
};
const regData = (bodyFormData) => {
  return axios({
    method: "POST",
    url: API_URL + "register/add/" + API_ORIGIN,
    data: bodyFormData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${token}`,
    },
  });
};
const getSitePermissions = () => {
  return axios({
    method: "GET",
    url: `${API_URL}sites/list-syc-sites/${API_ORIGIN}`,
    headers: {
      Authorization: `Basic ${token}`,
    },
  });
};
const UserformService = {
  getStates,
  getSitePermissions,
  getStoreLocation,
  getModels,
  regData,
};

export default UserformService;
